import {tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetHomeNewsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Fetcher} deps.repository
   * @param {Object} deps.log
   */
  constructor({repository, log}) {
    super({repository, log})

    this._repository = repository
    this._log = log
    this._fallbackResponse = {}
  }

  /**
   * @return {Promise<Object, Error>} returns array with feed arrays of news items
   * @property {Array} home news items
   */
  @tracer({metric: 'GetHomeNewsUseCase#execute'})
  execute() {
    return this._repository
      .getHomeNews()
      .then(response => response.toJSON())
      .catch(e => {
        console.log(e) // eslint-disable-line no-console
        this._log(`GetHomeNewsUseCase failed with error: ${e}`)
        return this._fallbackResponse
      })
  }
}
